import { render, staticRenderFns } from "./ManageForumPostComment.vue?vue&type=template&id=3902fb0a&"
import script from "./ManageForumPostComment.vue?vue&type=script&lang=js&"
export * from "./ManageForumPostComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports